<template>
  <div class="ml-header">
    <div class="left">蓝小房管理系统</div>
    <div class="right">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{$store.state.userInfo.name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="changPsw">修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="goOut">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      title="修改密码"
      width="600px"
      :visible="visible"
      :before-close="()=>{visible = false}"
      :destroy-on-close="true"
    >
      <el-form
        label-width="180px"
        :model="formData"
        :rules="rules"
        ref="ruleForm"
        class="rule-form"
      >
        <el-form-item label="旧密码：" prop="old_password">
          <el-input v-model="formData.old_password" placeholder="请输入内容" style="width: 220px;"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="new_password">
          <el-input v-model="formData.new_password" placeholder="请输入内容" style="width: 220px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="()=>{visible = false}">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submitForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Logo from "@/assets/logo.png";
import Api from "@/api/api";

export default {
  name: "mtop",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value == this.formData.old_password) {
        callback(new Error("新旧密码不能一样"));
      } else {
        callback();
      }
    };
    return {
      LogoImg: Logo,
      btnLoading: false,
      visible: false,
      formData: {
        old_password: "",
        new_password: ""
      },
      rules: {
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        new_password: [
          { required: true, validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    goOut() {
      this.$store.commit("reset");
      // setTimeout(() => {
      //   this.$router.push("/login");
      // }, 300);
    },
    changPsw() {
      this.formData = {
        old_password: "",
        new_password: ""
      };
      this.visible = true;
    },
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          Api.editPsw(this.formData).then(res => {
            if (res.code === 200) {
              this.$message({
                message: "修改成功",
                type: "success"
              });
              this.visible = false;
              setTimeout(() => {
                this.$store.commit("reset");
              }, 1500);
            } else {
              this.$message({
                message: res.msg,
                type: "error"
              });
            }
            this.btnLoading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ml-header {
  position: relative;
  line-height: 60px;
  height: 60px;
  color: #ffffff;
  .left {
    color: #ffffff;
    font-size: 18px;
    position: absolute;
    top: 0;
    height: 60px;
    img {
      width: 100px;
    }
  }
  .right {
    position: absolute;
    right: 50px;
    height: 60px;
    display: flex;
    img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
    }
  }
  .el-dropdown {
    color: #ffffff;
  }
}
</style>
